<template>
  <div class="mb-3">
    <Alert
      type="alert-info"
      text="Reply Buttons help you to suggest a list of quick replies to user.
      User can click these buttons to reply the bot. 
      You will see Reply Buttons here, once you create them in chat.
      In this section you have to link which chat should be invoked on clicking the reply buttons."
    ></Alert>
    <AlertLink link="/user-guide#ReplyButton" text="Read more about Reply Buttons here"></AlertLink>
    
    <div class="input-group mb-3" v-for="(action, index) in reply_buttons" :key="index">
      <input
        class="form-control"
        type="text"
        v-model="action.button.text"
        placeholder="Button text"
        readonly
      />
      <select class="form-control" v-model="action.chat">
        <option :value="null">Select chat</option>
        <option
          v-for="(chat_name, index) in chat_names"
          :value="chat_name"
          :key="index"
        >{{chat_name}}</option>
      </select>
      <div class="input-group-append">
        <span class="input-group-text">
          <input type="checkbox" class="form-check-input" v-model="action.prime" />Prime
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from "@/components/Alert.vue";
import AlertLink from "@/components/AlertLink.vue";


export default {
  name: "ReplyButtons",
  components: {
    Alert,
    AlertLink
  },
  props: {
    reply_buttons: Array,
    chat_names: Array
  }
};
</script>
